import { PageHeader } from 'antd';
import React from 'react'
import { connect } from 'react-redux';
import BusSignsMap from '../components/BusSignsMap';

class MapView extends React.Component {
    render() {
        document.title = 'Mapa označníků | Smart4City';
        return (
            <div>
                <PageHeader
                    title="Mapa"
                    subTitle="mapa autobusových označníků"
                    extra={[]}
                >
                    <BusSignsMap />
                </PageHeader>
            </div>
        )
    }
}
const mapStateToProps = state => ({
});

export default connect(
    mapStateToProps,
    {}
)(MapView)
